import { DiversionSettings } from '../../components/diversion/diversion-formatters';
import { createAppSelector } from '../hooks/store-hooks';
import { UDViewMapStyle } from '../../udView/udview';

export const diversionSettingsSelector = createAppSelector(
    [
        (x) => x.settings.diversionAirlineTerminology,
        (x) => x.settings.diversionNetworkTerminology,
        (x) => x.settings.diversionOtherTerminology,
        (x) => x.settings.diversionCapacityFieldAirline,
        (x) => x.settings.diversionCapacityFieldNetwork,
        (x) => x.settings.diversionCapacityFieldOther,
        (x) => x.settings.diversionPriorityType
    ],
    (airlineTerm, networkTerm, otherTerm, airlineCap, networkCap, otherCap, priorityType) =>
        ({
            terminology: {
                airline: airlineTerm,
                network: networkTerm,
                other: otherTerm
            },
            capacity: {
                airline: airlineCap,
                network: networkCap,
                other: otherCap
            },
            priorityType
        }) satisfies DiversionSettings
);

export const notesSelector = createAppSelector([(x) => x.notes.notes, (_, ids: string[]) => ids], (notes, ids) =>
    ids.flatMap((id) => (notes[id] ? notes[id] : []))
);

const TERRAIN_SUPPORTED_STYLES = [UDViewMapStyle.terrainSatellite, UDViewMapStyle.terrainStreets];
export const hasTerrainOptionSelector = createAppSelector([(x) => x.workspace.items[x.workspace.selectedId]?.view.map.style], (style) => {
    if (!style) {
        return false;
    }
    
    return TERRAIN_SUPPORTED_STYLES.includes(style);
});
